import React, {useState} from "react";
import ProfileContainer from "../components/ProfileContainer";
import ProfileCertificationRow from "../components/ProfileCertificationRow";

const MAX_LENGTH = 3;

const TalentProfileCertifications = ({items = []}) => {
    const [isMoreOpen, setIsMoreOpen] = useState(false);

    const sortedCertifications = TB.orderBy(items, 'display_index');
    return (
        <div id="certifications" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">Certifications  {!!sortedCertifications.length && `(${sortedCertifications.length})`}</h4>

                    {!sortedCertifications.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Certifications Available</p>
                        </div>
                    )}

                    <div className="flex flex-col divide-y">
                        {sortedCertifications?.slice(0, isMoreOpen ? sortedCertifications.length : MAX_LENGTH).map(certification => (
                            <ProfileCertificationRow key={certification.id} certification={certification} />
                        ))}
                    </div>

                    {sortedCertifications.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsMoreOpen(!isMoreOpen)}
                            >
                                <p>{sortedCertifications.length - MAX_LENGTH} {isMoreOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", {'rotate-180': isMoreOpen})}/>
                                </div>
                            </button>
                        </div>
                    )}
                </div>
            </ProfileContainer>
        </div>
    )
}

export default TalentProfileCertifications;